var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktopChartUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5C1.34315 1.5 0 2.84315 0 4.5V15C0 16.6569 1.34315 18 3 18H21C22.6569 18 24 16.6569 24 15V4.5C24 2.84315 22.6569 1.5 21 1.5H3ZM3 3C2.17157 3 1.5 3.67157 1.5 4.5V15C1.5 15.8284 2.17157 16.5 3 16.5H21C21.8284 16.5 22.5 15.8284 22.5 15V4.5C22.5 3.67157 21.8284 3 21 3H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H10.5V22.5H9V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18H15V22.5H13.5V18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.25C4.5 22.8358 4.83579 22.5 5.25 22.5H18.75C19.1642 22.5 19.5 22.8358 19.5 23.25C19.5 23.6642 19.1642 24 18.75 24H5.25C4.83579 24 4.5 23.6642 4.5 23.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9578 4.96291C19.9212 4.87445 19.867 4.79158 19.7951 4.71967C19.7231 4.64776 19.6403 4.59351 19.5518 4.55691C19.4634 4.52024 19.3664 4.5 19.2647 4.5L14.9246 4.68196C14.5104 4.68196 14.1746 5.01775 14.1746 5.43196C14.1746 5.84618 14.5104 6.18196 14.9246 6.18196L17.4541 6L12.6967 10.7574L10.8484 8.90901C10.5555 8.61612 10.0806 8.61612 9.78769 8.90901L4.71967 13.977C4.42678 14.2699 4.42678 14.7448 4.71967 15.0377C5.01256 15.3306 5.48744 15.3306 5.78033 15.0377L10.318 10.5L12.1664 12.3484C12.4593 12.6412 12.9341 12.6412 13.227 12.3484L18.5147 7.06066L18.4174 9.67447C18.4174 10.0887 18.7532 10.4245 19.1674 10.4245C19.5816 10.4245 19.9174 10.0887 19.9174 9.67447L20.0147 5.25147C20.0147 5.24636 20.0147 5.24126 20.0146 5.23616C20.0129 5.14309 19.994 5.05028 19.9578 4.96291Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopChartUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop-chart-up.8f2b223767003ef4cdaa8f1e925868b2.svg";